
import styled, { css } from 'styled-components';






export const Title = /*#__PURE__*/styled.div.withConfig({ displayName: "styled__Title", componentId: "sc-kt1ki8-0" })(["", ";min-height:", "px;"],
({ theme, typography }) => css(theme.typography[typography]),
({ minHeight }) => minHeight);